// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsManagement_container__25zbE","title":"NotificationsManagement_title__1xdir","switch":"NotificationsManagement_switch__2Duvn"};